import React, { useState } from 'react';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, subject, message } = formData;
    const mailtoLink = `mailto:info@funzocoffee.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(`Name: ${name}\nEmail: ${email}\n\nMessage:\n${message}`)}`;
    window.location.href = mailtoLink;
    setFormData({ name: '', email: '', subject: '', message: '' }); // Clear form after submission
  };

  return (
    <main className="w-full">
      <section className="w-full bg-orange-50 py-16">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div className="flex flex-col justify-center gap-6 text-center lg:text-left">
            <h1 className="font-serif text-3xl lg:text-4xl font-semibold text-coffee-dark leading-tight tracking-tight">Get in Touch</h1>
            <p className="mt-2 text-md text-gray-600">
              We’d love to hear from you! Whether you’re a distributor, coffee buyer, or investor, let’s discuss how we can collaborate to grow together.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a href="#contact-form" className="px-6 py-3 bg-coffee-primary text-white rounded-lg shadow-md transition-all duration-150 hover:bg-coffee-dark hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-coffee-accent">Send Us a Message →</a>
            </div>
          </div>
          <div className="relative rounded-xl overflow-hidden shadow-xl">
            <img src="/logo/FUNZOLOGOwhite.jpg?query=%7Buganda%20coffee%20farm%7D&w=1024&h=640" alt="Ugandan coffee farm at dawn" className="w-full h-96 object-cover"/>
          </div>
        </div>
      </section>
      <section id="contact-details" className="w-full bg-white py-16 border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="flex flex-col">
            <div className="p-6 rounded-xl border border-gray-200 bg-orange-50 shadow-sm">
              <h2 className="font-serif text-4xl text-coffee-dark">Contact Information</h2>
              <ul className="flex flex-col gap-5">
                <li className="flex items-start gap-4">
                  <img src="https://api.iconify.design/lucide-map-pin.svg?color=%235C3A21" alt="" className="w-6 h-6 mt-0.5"/>
                  <div className="flex flex-col">
                    <span className="font-medium text-lg text-gray-700">Head Office</span>
                    <span className="text-base text-gray-600">UHMG Building, Ground Floor. Plot 20-21 Martyrs Crescent.
P.O Box 23866
Nakawa Uganda</span>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <img src="https://api.iconify.design/lucide-phone.svg?color=%235C3A21" alt="" className="w-6 h-6 mt-0.5"/>
                  <div className="flex flex-col">
                    <span className="font-medium text-lg text-gray-700">Phone</span>
                    <a href="tel:+256751449095" className="text-base text-coffee-primary hover:text-coffee-secondary">+256 751 449 095</a>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <img src="https://api.iconify.design/lucide-mail.svg?color=%235C3A21" alt="" className="w-6 h-6 mt-0.5"/>
                  <div className="flex flex-col">
                    <span className="font-medium text-lg text-gray-700">Email</span>
                    <a href="mailto:info@funzocoffee.com" className="text-base text-coffee-primary hover:text-coffee-secondary">info@funzocoffee.com</a>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <img src="https://api.iconify.design/lucide-globe.svg?color=%235C3A21" alt="" className="w-6 h-6 mt-0.5"/>
                  <div className="flex flex-col">
                    <span className="font-medium text-lg text-gray-700">Website</span>
                    <a href="https://www.funzocoffee.com" className="text-base text-coffee-primary hover:text-coffee-secondary">www.funzocoffee.com</a>
                  </div>
                </li>
              </ul>
            </div>
            
          </div>
          <div className="flex flex-col">
            <div id="contact-form" className="p-6 rounded-xl border border-gray-200 bg-orange-50 shadow-sm">
              <h2 className="font-serif text-4xl text-coffee-dark">Send us a message</h2>
              <form onSubmit={handleSubmit} className="flex flex-col gap-5">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div className="flex flex-col gap-2">
                    <label htmlFor="contact-name" className="text-sm text-gray-700">Full Name</label>
                    <input type="text" id="contact-name" name="name" required aria-required="true" placeholder="Your name" className="p-3 rounded-lg border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-coffee-secondary" value={formData.name} onChange={handleChange}/>
                  </div>
                  <div className="flex flex-col gap-2">
                    <label htmlFor="contact-email" className="text-sm text-gray-700">Email Address</label>
                    <input type="email" id="contact-email" name="email" required aria-required="true" placeholder="you@example.com" className="p-3 rounded-lg border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-coffee-secondary" value={formData.email} onChange={handleChange}/>
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                    <label htmlFor="contact-subject" className="text-sm text-gray-700">Subject</label>
                  <div className="relative">
                    <input type="text" id="contact-subject" name="subject" required aria-required="true" placeholder="How can we help?" className="w-full p-3 rounded-lg border border-gray-300 bg-white focus:outline-none focus:ring-2 focus:ring-coffee-secondary" value={formData.subject} onChange={handleChange}/>
                    <span className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none">
                      <img src="https://api.iconify.design/lucide-pencil.svg?color=%236B6157" alt="" className="w-5 h-5"/>
                    </span>
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  <label htmlFor="contact-message" className="text-sm text-gray-700">Message</label>
                  <textarea id="contact-message" name="message" rows="6" required aria-required="true" placeholder="Tell us more about your inquiry..." className="w-full p-3 rounded-lg border border-gray-300 bg-white min-h-[120px] text-base focus:outline-none focus:ring-2 focus:ring-coffee-secondary" value={formData.message} onChange={handleChange}></textarea>
                </div>
                <div className="flex items-center justify-end mt-2">
                  <button type="submit" className="px-6 py-3 bg-coffee-primary text-white rounded-lg shadow-md transition-all duration-150 hover:bg-coffee-dark focus:outline-none focus:ring-2 focus:ring-coffee-accent">
                    Send Message
                  </button>
                </div>
              </form>
            </div>
          </div>

         
        </div>
      </section>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.745804969206!2d32.616023774964674!3d0.34544329965116916!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dba2f00b37a45%3A0x3e6b58f359617865!2sUganda%20Health%20Marketing%20Group!5e0!3m2!1sen!2sug!4v1763881085338!5m2!1sen!2sug" className="w-full h-[500px]" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>      
    </main>
  );
};

export default ContactUs;
